export default {
    decorate: function(field) {
        field.addClass("conceal")
            .attr("autocomplete", "off")
            .attr("autocapitalize", "off")
            .attr("autocorrect", "off")
            .attr("spellcheck", "false");
    }
}